<script setup>
import { h, isVNode } from 'vue';

const props = defineProps({
  icon: { type: [String, Object, Function], required: true },
});

const isImageAsset = icon =>
  typeof icon === 'string' &&
  (icon.startsWith('data:image/') ||
    /\.(?:png|jpe?g|webp|svg)(?:\?.*)?$/i.test(icon));

const renderIcon = () => {
  if (!props.icon) return null;
  if (typeof props.icon === 'function' || isVNode(props.icon)) {
    return props.icon;
  }
  if (isImageAsset(props.icon)) {
    return h('img', {
      src: props.icon,
      alt: '',
      draggable: false,
      'aria-hidden': 'true',
    });
  }
  return h('span', { class: props.icon });
};
</script>

<template>
  <component :is="renderIcon" />
</template>
